import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Link } from "react-scroll"
import moment from "moment"

import Panel from "shared/components/Panel"

import BasicInformationTable from "./BasicInformationTable"
import CourierInformationTable from "./CourierInformationTable"

import styles from "./Information.css"

const renderFAQLink = () => (
  <span className="fs-12">
    Read our <Link className="pointer" to="faq" spy smooth offset={-50}>frequently asked questions</Link>
  </span>
)
const LastUpdate = ({ timestamp }, { t: translate }) => {
  if (timestamp) {
    const date = moment.unix(timestamp).format("DD-MM-YYYY, h:mm:ss a")
    return (
      <Fragment>
        <div className="clearfix visible-xs" />
        <span className="fs-12">
          <span className={[styles.bar, "hidden-xs"].join(" ")}>|</span>
          {translate("Last update: {date}", {
            date,
          })}
        </span>
      </Fragment>
    )
  }
  return null
}

LastUpdate.propTypes = {
  timestamp: PropTypes.number.isRequired,
}
LastUpdate.contextTypes = {
  t: PropTypes.func.isRequired,
}

const Information = ({ parcel }) => (
  <Panel className="m-b-20">
    <div className="row">
      <div className="col-sm-6">
        <BasicInformationTable shipment={parcel.shipment} />
        <div className="hidden-xs hidden-sm">
          <div className={styles.container}>
            {renderFAQLink()}
            <LastUpdate timestamp={parcel.last_tracking_update && parcel.last_tracking_update.timestamp} />
          </div>
        </div>
      </div>
      {parcel.last_mile_courier_info && (
        <div className="col-sm-6">
          <CourierInformationTable courier={parcel.last_mile_courier_info} />
        </div>
      )}
    </div>
    <div className="row visible-xs visible-sm">
      <div className="col-md-6">
        <div className={styles.container}>
          {renderFAQLink()}
          <LastUpdate timestamp={parcel.last_tracking_update && parcel.last_tracking_update.timestamp} />
        </div>
      </div>
    </div>
  </Panel>
)

Information.propTypes = {
  parcel: PropTypes.shape({
    shipment: PropTypes.shape({
      destination: PropTypes.shape({
        country: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        postal_code: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
      }),
    }),
    last_mile_courier_info: PropTypes.object,
    last_tracking_update: PropTypes.shape({
      timestamp: PropTypes.number,
      string: PropTypes.string,
    }),
  }).isRequired,
}

Information.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default Information



// WEBPACK FOOTER //
// ./src/views/Parcel/components/Information/Information.js